export default function switchArticleLayout(layout: string) {
  const activeLayout = layout === 'b' ? 'a' : 'b';
  const activeLayoutElements = document.querySelectorAll(`[data-layout-${activeLayout}]`);
  const layoutElements = document.querySelectorAll(`[data-layout-${layout}]`);
  const layoutClassElements = document.querySelectorAll(`[data-layout-${layout}-class]`);

  const articleContainers = document.querySelectorAll('.C-article');
  if (articleContainers.length) {
    articleContainers.forEach(element => {
      const article = element as HTMLElement;

      if (article?.classList.contains(`C-article-layout-${activeLayout}`)) {
        article.classList.remove(`C-article-layout-${activeLayout}`);
      }

      article?.classList.add(`C-article-layout-${layout}`);
    });
  }

  if (activeLayoutElements.length) {
    activeLayoutElements.forEach(element => {
      const layoutElement = element as HTMLElement;
      layoutElement.style.display = 'none';
    });
  }

  if (layoutElements.length) {
    layoutElements.forEach(element => {
      const layoutElement = element as HTMLElement;
      layoutElement.style.display = 'block';
    });
  }

  if (layoutClassElements.length) {
    layoutClassElements.forEach(element => {
      const layoutElement = element as HTMLElement;
      layoutElement.className = layoutElement.dataset[`layout${layout.toUpperCase()}Class`] as string;
    });
  }
}
